export const getDateFromDaysAgo = (days: number) => {
  const date = new Date();
  date.setDate(date.getDate() - Math.abs(Math.ceil(days)));
  return date;
};
